import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './images/info.svg'
import _imports_1 from './images/info-mobile.svg'


const _withScopeId = n => (_pushScopeId("data-v-33f72892"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "delivery-warning"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"delivery-warning__icon\" data-v-33f72892><div class=\"delivery-warning__icon--desktop\" data-v-33f72892><img src=\"" + _imports_0 + "\" data-v-33f72892></div><div class=\"delivery-warning__icon--mobile\" data-v-33f72892><img src=\"" + _imports_1 + "\" data-v-33f72892></div></div>", 1)
const _hoisted_3 = {
  key: 0,
  class: "delivery-warning__description delivery-warning__description--mobile"
}
const _hoisted_4 = {
  key: 1,
  class: "delivery-warning__description delivery-warning__description--mobile"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-breaker" }, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "delivery-warning"
}
const _hoisted_7 = { class: "delivery-warning__price-for-delivery rouble-symbol" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.isWorks || _ctx.isDelayedOrder)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.isDelayedOrder)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, " В корзине есть товары по предзаказу "))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createTextVNode(" Доставим после " + _toDisplayString(_ctx.startTimeTitle) + " ... ", 1),
              _hoisted_5,
              _createTextVNode(" Сейчас закрыты ")
            ]))
      ]))
    : (_ctx.priceForDelivery)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, " Добавьте еще на " + _toDisplayString(_ctx.priceForDelivery), 1)
        ]))
      : _createCommentVNode("", true)
}